import { TRADER, TRADER_MAPPING_NAME } from "../../Constants/TableFilter.constants";
import GenericMappingTable from "../ApiSettings/Index";

const TraderMapping: React.FC = () => (
  <GenericMappingTable
    pageTitle="Trader Mapping"
    entityLabel={TRADER_MAPPING_NAME}
    entityFieldName="API_Trader_name"
    selectLabel={TRADER}
    selectFieldName="trader"
    selectDisplayFieldName="trader_name"
    dataApiUrl="/paper-app/exchange_trader_mapping/"
    updateApiUrl="/paper-app/exchange-trader-mapping/update/"
    bulkDeleteApiUrl="/paper-app/api-trader-mapping/bulk-delete/"
    optionsApiUrl="/paper-app/Cost-Trader-Dropdown/"
    queryKeyData="exchange-trader-mapping"
    queryKeyOptions="api-broker-list"
    deleteMode="bulk-delete"
    fileUploadApiUrl="/paper-app/exchange-trader-mapping/upload-csv/"
    exportAllApiUrl="/paper-app/exchange-trader-mapping/export-csv/"
    exportAllFileName="trader_mapping.csv"
    templateDownloadApiUrl="/paper-app/exchange-trader-mapping/download-template/"
    templateFileName="exchange_trader_mapping_template.csv"
  />
);

export default TraderMapping;